var _desc, _defs, _rect, _g, _circle, _g2, _g3, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiftswap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 720",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "GiftSwap project illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "description"
  }, "Connected gift boxes representing a coordinated gift exchange")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#151812"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d0f0a"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 720,
    fill: "url(#bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#39ff14",
    strokeOpacity: 0.23,
    strokeWidth: 3,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286 230 600 360 914 230M286 490 600 360 914 490"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 360,
    r: 205,
    strokeDasharray: "8 18"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 360,
    r: 150,
    fill: "#39ff14",
    opacity: 0.08,
    filter: "url(#glow)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(484 244)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 94,
    width: 196,
    height: 150,
    rx: 18,
    fill: "#20251b",
    stroke: "#39ff14",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 54,
    width: 232,
    height: 62,
    rx: 16,
    fill: "#2a3023",
    stroke: "#39ff14",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 56v188M79 54c-43-12-45-62-9-68 35-6 46 44 46 68M153 54c43-12 45-62 9-68-35-6-46 44-46 68",
    fill: "none",
    stroke: "#39ff14",
    strokeWidth: 12,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#151812",
    stroke: "#7fff00",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 175,
    width: 128,
    height: 104,
    rx: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286 175v104M210 196h152"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850,
    y: 175,
    width: 128,
    height: 104,
    rx: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914 175v104M838 196h152"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 441,
    width: 128,
    height: 104,
    rx: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286 441v104M210 462h152"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850,
    y: 441,
    width: 128,
    height: 104,
    rx: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914 441v104M838 462h152"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 652,
    textAnchor: "middle",
    fill: "#a3b090",
    fontFamily: "monospace",
    fontSize: 28,
    letterSpacing: 8
  }, "GIFTSWAP")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftswap);
export default __webpack_public_path__ + "static/media/giftswap.5eaaa73deb72a62d4d57431824579adc.svg";
export { ForwardRef as ReactComponent };